import { map } from "lodash";
import { MEDIA_URL } from "../../axios";

export const getFormattedSongs = (songs) =>
  map(songs, (item) => ({
    ...item,
    url: `${MEDIA_URL}/songs/${item.fileName}`,
  }));
